import {Link, useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useAuth} from '../lib/auth';

interface NavItem {
  path: string;
  key: string;
  icon: string;
}

const navItems: NavItem[] = [
  {path: '/', key: 'nav.agent', icon: '✦'},
  {path: '/sites', key: 'nav.website', icon: '◰'},
  {path: '/catalog', key: 'nav.catalog', icon: '▦'},
  {path: '/versions', key: 'nav.versions', icon: '◌'},
  {path: '/publish', key: 'nav.publish', icon: '↗'},
];

export default function AppLayout({children}: {children: React.ReactNode}) {
  const {user, logout} = useAuth();
  const location = useLocation();
  const {t} = useTranslation();

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar-brand">
          {t('app.name')} <span className="accent">{t('app.brand')}</span>
        </div>
        <nav className="sidebar-nav">
          {navItems.map((item) => {
            const isActive =
              item.path === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`sidebar-nav-item ${isActive ? 'active' : ''}`}
              >
                <span className="sidebar-nav-icon">{item.icon}</span>
                <span>{t(item.key)}</span>
              </Link>
            );
          })}
        </nav>
        <div className="sidebar-footer">
          <Link className="sidebar-settings-link" to="/settings">高级设置</Link>
          {user && (
            <>
              <div className="sidebar-user">{user.name}</div>
              <div className="sidebar-user-email">{user.email}</div>
              <button onClick={logout} className="sidebar-logout">
                {t('logout.button')}
              </button>
            </>
          )}
        </div>
      </aside>
      <main className="app-main">{children}</main>
    </div>
  );
}
